// extracted by mini-css-extract-plugin
module.exports = {"btn":"util-DownloadAppButton__btn--fo80D","ctaSvg":"util-DownloadAppButton__ctaSvg--2XXct"};